$(function () {

    function animateCounters(selector = ".counter") {
        const counters = document.querySelectorAll(selector);

        counters.forEach(counter => {
            const target = +counter.getAttribute("data-target");
            let count = 0;
            const speed = target / 100;

            function updateCounter() {
                if (count < target) {
                    count += speed;
                    counter.textContent = Math.floor(count);
                    requestAnimationFrame(updateCounter);
                } else {
                    counter.textContent = target;
                }
            }

            updateCounter();
        });
    }

    // Call the function
    animateCounters();

});
